/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Navigation.scss';
import NavigationLink from '../NavigationLink';

class Navigation extends React.Component {
  render() {
    return (
      <nav className={s.root}>
        <ul className={s.navRoot}>
          <li className={s.navItem}>
            <NavigationLink to="/news" title="News" />
          </li>
          <li className={s.navItem}>
            <NavigationLink to="/documents" title="Documents" />
          </li>
          <li className={s.navItem}>
            <NavigationLink to="/about" title="About" />
          </li>
        </ul>
      </nav>
    );
  }
}

export default withStyles(s)(Navigation);
